var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 503,
    viewBox: "0 0 380 503",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4477 100.238C11.6287 63.2708 39.5824 32.6838 76.2938 28.1885L295.884 1.29986C340.587 -4.17396 380 30.7071 380 75.7439V418.384C380 458.661 348.186 491.748 307.939 493.326L77.9724 502.344C34.4853 504.05 -1.31806 468.505 0.0716653 425.007L10.4477 100.238Z",
    fill: "#FFEDD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.edd7fe9f22aba1876426251b49cf8073.svg";
export { ForwardRef as ReactComponent };